import { useTranslation } from "next-i18next";
import { arrayOf, bool, shape, string } from "prop-types";

import Link from "~components/Link";
import ChevronRight from "~public/icons/chevron-right.svg";
import Home from "~public/icons/home.svg";
import classnames from "~utils/classnames/classnames";

import classes from "./Breadcrumbs.module.scss";

const Crumb = ({ title, slug, last, dots }) => (
  <div
    className={classnames(
      classes.crumb,
      last ? classes.crumb_last : null,
      dots ? classes.crumb_dots : null,
    )}
  >
    <ChevronRight />
    {last ? (
      <span>{title.replaceAll("_", " ")}</span>
    ) : (
      <Link href={slug}>{title.replaceAll("_", " ")}</Link>
    )}
  </div>
);

Crumb.propTypes = {
  title: string.isRequired,
  slug: string.isRequired,
  last: bool.isRequired,
  dots: bool.isRequired,
};

const Breadcrumbs = ({ homeUrl = "/", homeTitle, crumbs }) => {
  const { t } = useTranslation();
  return (
    <div className={classes.breadcrumbs}>
      <div className={classes.crumb_home}>
        <Link href={homeUrl} title={homeTitle ?? t("homepage")}>
          <Home focusable={false} />
        </Link>
      </div>
      {crumbs.map((crumb, index) => (
        <Crumb
          key={crumb.url}
          title={crumb.title}
          slug={crumb.url}
          last={index === crumbs.length - 1}
          dots={index < crumbs.length - 2}
        />
      ))}
    </div>
  );
};

Breadcrumbs.propTypes = {
  homeUrl: string,
  homeTitle: string,
  crumbs: arrayOf(
    shape({
      title: string.isRequired,
      url: string.isRequired,
    }),
  ),
};

export default Breadcrumbs;
